import React from "react";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import Layout from "../components/Layout";
import AdminRoutes from "./AdminRoutes";
import userProfileSelectors from '../../../../redux/UserProfile/selectors'
import { ACCESS_DENIED } from "client/utils/Permissions";
import { CONSTANTS } from "client/utils/constants";
import LoadingWrapper from "../../../CommonComponents/LoadingWrapper"

const AdminDash = () => {

  const {
    userDetails,
  }: any = useSelector(
    (state: any) => ({
      userDetails: userProfileSelectors.getUserDetails(state),
    }));

  const getUserRoles = () => {
    let roles = userDetails?.roles?.map((role: any) => role.roleName)
    return roles
  }


  let content = null

  const roles = getUserRoles() || [];
  const hasAccess = roles.includes(CONSTANTS.SUPER_ADMIN) || roles.includes('AppViewer') || roles.includes('AppViewer-Leadr');
  if (!hasAccess) {
    content = (
      <div className="access-denied">
        <h1>ACCESS DENIED</h1>
        <h6>{ACCESS_DENIED}</h6>
      </div>
    )
  } else {
    content = (
      <Layout>
        <Routes>
          {AdminRoutes.map((prop, index) => (
            <Route key={index} path={prop.path} element={<prop.component />} />
          ))}
        </Routes>
      </Layout>
    )
  }

  return (
    <>
    <LoadingWrapper style={{height: 'inherit', width: 'inherit'}} isLoading={JSON.stringify(userDetails) === '{}'}  data-attribute="index_Default_LoadingWrapper">
      {content}
    </LoadingWrapper>
    </>
  );
};

export default AdminDash;
